import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Modal, DatePicker, TreeSelect, Card, Tabs, Button, Row, Col, Alert, Divider, Table, Tag } from 'antd';
import { ReloadOutlined, UserSwitchOutlined, DownloadOutlined, SwapOutlined, ExportOutlined } from '@ant-design/icons';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import AppointmentForm from '@/components/appointments/AppointmentForm';
import AppointmentUpdateStatus from '@/components/appointments/AppointmentUpdateStatus';
import { checkPermission } from '@/utils/permission';
import { cleanObject, makeTree, appointmentName, appointmentNaStatus, appointmentStatus, appointmentTeleStatus, formatNumber } from '@/utils/helpers';
import BaseSelect from '@/components/Elements/BaseSelect';
import { isMobile } from 'react-device-detect';
import html2canvas from 'html2canvas';
import moment from 'moment';
import {
    getListAppointments,
    exportAppointmentsExcel,
    transferAppointmentToStaff,
    getSpecificAppointment,
    removeAppointment,
    moveAppointment,
    getAppointmentsStatistics
} from '@/redux/actions/appointmentActions';
import DynamicTable from '@/components/DynamicTable';
import FilterableMultiSelect from '@/components/FilterableMultiSelect';
import { NotificationManager } from 'react-notifications';
import { Helmet } from 'react-helmet';
import TelesaleFollowUpAssignForm from '@/components/TelesaleFollowUpAssignForm';
import { fetchFilters } from '@/redux/actions/filterActions';
import { appointmentColumns } from './appointmentColumns';
import AppointmentDetail from '@/components/appointments/AppointmentDetail';


const { confirm } = Modal;
const { RangePicker } = DatePicker;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/appointments',
        breadcrumbName: 'Lịch hẹn',
    },
]
const { TabPane } = Tabs;
class AppointmentList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            selectedRows: [],
            isOpenForm: false,
            currentItem: null,
            isOpenDetail: false,
            currentData: null,
            isOpenStatusForm: false,
            loadingMoveAppointment: false,
            loadingCapture: false,
            isTelesaleAssignOpen: false,
            isLoadingExport: false,
            pendingChangeSchedulePayload: null,
            scheduledAt: null,
        }

        this.tableRef = createRef();
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
        this.props.fetchFilters();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }
        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_at_from = moment(value[0]).format('YYYY-MM-DD');
                query.created_at_to = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_at_from;
                delete query.created_at_to;
            }
        }
        if (name === 'scheduled_at') {
            if (value && value.length > 0) {
                query.scheduled_from = moment(value[0]).format('YYYY-MM-DD');
                query.scheduled_to = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.scheduled_from;
                delete query.scheduled_to;
            }
        }
        delete query.created_at;
        delete query.scheduled_at;
        query = cleanObject(query);
        //console.log("query: ", query)
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onEdit(id) {
        this.props.getSpecificAppointment(id).then(res => {
            this.toggleOpenForm(true, res);
        })
    }

    onRemove() {
        const query = qs.parse(this.props.location.search.slice(1));
        this.props.removeAppointment(this.state.selectedRowKeys).then(() => {
            this.setState({ selectedRowKeys: [] });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
            this.loadData(query);
        })
    }

    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeAppointment([id]).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDetail(id) {
        this.props.getSpecificAppointment(id).then(res => {
            this.toggleOpenDetail(true, res);
        })
    }

    loadData(query) {
        console.log('query: ', query)
        this.setState({ isLoading: true });
        this.props.getListAppointments(query).then(() => {
            this.setState({ isLoading: false });
        })
        this.props.getAppointmentsStatistics(query);
    }

    openStatusUpdateModal(id, isOpenStatusForm) {
        this.props.getSpecificAppointment(id).then(res => {
            this.setState({ isOpenStatusForm: isOpenStatusForm, currentItem: res });
        })
    }

    onCancel() {
        this.props.form.resetFields();
        this.setState({
            selectedRowKeys: [],
            selectedRows: [],
            isOpenStatusForm: false,
            isMoveAppointmentModalOpen: false,
            loadingMoveAppointment: false,
            isTelesaleAssignOpen: false,
        })
    }

    handleCaptureClick = async () => {
        this.setState({ loadingCapture: true });

        const table = this.tableRef.current;
        if (!table) return;

        // Tạo một bảng tạm thời với kích thước lớn
        const clonedTable = table.cloneNode(true);
        clonedTable.style.width = 'max-content';
        clonedTable.style.height = 'max-content';

        // Thêm bảng tạm thời vào body để tránh các ràng buộc CSS
        document.body.appendChild(clonedTable);

        // Chụp ảnh của bảng tạm thời
        await html2canvas(clonedTable).then(canvas => {
            // Chuyển canvas thành hình ảnh và tải xuống
            const imgData = canvas.toDataURL('image/jpg');
            const link = document.createElement('a');
            const d = new Date();
            const f = (n) => (`0${n}`).slice(-2);
            link.href = imgData;
            link.download = `lich-hen-${[f(d.getDate()), f(d.getMonth() + 1), d.getFullYear(), f(d.getHours()), f(d.getMinutes())].join('-')}.jpg`;
            link.click();

            // Loại bỏ bảng tạm thời sau khi đã chụp ảnh
            document.body.removeChild(clonedTable);
        });
        this.setState({ loadingCapture: false });
    };


    handleMoveAppointment = (e) => {
        e.preventDefault();

        this.props.form.validateFields(['scheduled_at', 'name'], async (err, values) => {
            if (err) return;

            const { selectedRowKeys } = this.state;

            const payload = {
                ...values,
                appointment_ids: selectedRowKeys
            };

            this.setState({ loadingMoveAppointment: true, scheduledAt: values.scheduled_at });

            console.log('Move appointment payload: ', payload);

            try {
                const res = await this.props.moveAppointment(payload);
                // THÀNH CÔNG → SHOW MODAL KẾT QUẢ
                this.showTransferResultModal({
                    transferred: res?.transferred || [],
                    conflicted: res?.conflicted || [],
                });

            } catch (error) {
                this.setState({ loadingMoveAppointment: false });
                console.error('Move appointment error:', error);
            } finally {
                this.setState({ loadingMoveAppointment: false });
            }
        });
    };

    showTransferResultModal = ({ transferred = [], conflicted = [] }) => {
        Modal.info({
            title: 'Kết quả chuyển lịch',
            width: isMobile ? '100%' : 700,
            bodyStyle: { padding: 15 },
            className: 'confirm-modal',
            okText: 'Đóng',

            content: (
                <div>
                    {/* ===== LỊCH ĐÃ CHUYỂN ===== */}
                    <Alert
                        type="success"
                        showIcon
                        className="mb-2"
                        message={`Đã chuyển thành công ${transferred.length} lịch`}
                    />

                    {transferred.length > 0 && (
                        this.renderTransferredTable(transferred)
                    )}

                    {/* ===== LỊCH BỊ TRÙNG ===== */}
                    {conflicted.length > 0 && (
                        <div className='mt-4'>
                            <Alert
                                type="warning"
                                showIcon
                                className="mb-2"
                                message={`Có ${conflicted.length} lịch bị trùng, không chuyển nhưng đã cập nhật trạng thái là đã chuyển lịch.`}
                            />
                            {this.renderConflictedTable(conflicted)}
                        </div>
                    )}
                </div>
            ),

            onOk: () => {
                // Sau khi user xem xong mới reload
                const query = qs.parse(this.props.location.search.slice(1));
                this.loadData(query);
                this.onCancel();
            }
        });
    };

    renderTransferredTable = (data) => (
        <Table
            size="small"
            rowKey="id"
            pagination={false}
            columns={[
                {
                    title: 'Khách hàng',
                    dataIndex: 'customer_name',
                    width: 250
                },
                {
                    title: 'Thời gian mới',
                    dataIndex: 'time',
                    render: t => moment(this.state.scheduledAt).format('DD/MM/YYYY HH:mm'),
                },
                {
                    title: 'Cơ sở',
                    dataIndex: 'branch_name',
                },
                {
                    title: 'Trạng thái',
                    dataIndex: 'status',
                    render: () => <Tag color="green">Đã chuyển</Tag>,
                },
            ]}
            dataSource={data}
        />
    );

    renderConflictedTable = (data) => (
        <Table
            size="small"
            rowKey="id"
            pagination={false}
            columns={[
                {
                    title: 'Khách hàng',
                    dataIndex: 'customer_name',
                    width: 250
                },
                {
                    title: 'Thời gian',
                    dataIndex: 'time',
                    render: t => moment(t).format('DD/MM/YYYY HH:mm'),
                },
                {
                    title: 'Cơ sở',
                    dataIndex: 'branch_name',
                },
                {
                    title: 'Trạng thái',
                    dataIndex: 'status',
                    render: () => <Tag color="orange">Trùng lịch</Tag>,
                },
            ]}
            dataSource={data}
        />
    );

    changeName(value) {
        if (value == 'CHUADATDUOCLICH' || value == 'CHUAXACDINHLICH') {
            this.setState({ requireTime: false })
            this.props.form.setFieldsValue({ time: null })
        } else {
            this.setState({ requireTime: true })
        }
    }

    startExcelExport() {
        const { auth } = this.props;

        const query = qs.parse(this.props.location.search.slice(1));

        this.setState({ isLoadingExport: true });

        // Gọi API exportAppointmentsExcel, nhưng không chờ response
        this.props.exportAppointmentsExcel(query).catch(() => {
            NotificationManager.error(
                "Có lỗi xảy ra trong quá trình gửi yêu cầu xuất file. Vui lòng thử lại sau.",
                "Lỗi",
                9000
            );
        }).finally(() => {
            this.setState({ isLoadingExport: false });
        });

        this.setState({ isLoadingExport: false });
        // Thông báo ngay lập tức cho người dùng
        NotificationManager.success(
            `Quá trình xuất file đang được thực hiện. 
        File kết quả sẽ được gửi vào email ${auth.email} trong ít phút.`,
            "Thông báo",
            9000
        );
    }

    render() {
        var { appointments, pagination, users, doctors, statistics, filterData } = this.props;
        var { isLoading, selectedRowKeys,
            isOpenForm,
            currentItem, isOpenDetail,
            currentData,
            isOpenStatusForm,
            isMoveAppointmentModalOpen,
            loadingMoveAppointment,
            selectedRows,
            requireTime,
            loadingCapture,
            isLoadingExport,
            isTelesaleAssignOpen
        } = this.state;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const hasSelected = selectedRowKeys.length > 0;
        const { getFieldDecorator } = this.props.form;
        var query = qs.parse(this.props.location.search.slice(1));


        const customerIds = selectedRows.map(item => item.customer_id);

        // Helmet được chèn vào đây
        const pageTitle = 'LỊCH HẸN - CHINGO DENTAL';

        const customerSource = filterData?.sources;
        const branchActiveList = filterData?.branches;
        const services = filterData?.services;
        const customerStatus = filterData?.statuses;

        const service = makeTree(services || [], 0);

        const columns = appointmentColumns({
            onDetail: (id) => this.onDetail(id),
            onEdit: (id) => this.onEdit(id),
            openStatusUpdateModal: (id, isOpenStatusForm) => this.openStatusUpdateModal(id, isOpenStatusForm),
        });

        const tables = <DynamicTable
            dataSource={appointments || []}
            columns={columns}
            isLoading={isLoading}
            pagination={pagination}
            rowSelection={rowSelection}
            ref={this.tableRef}
            moduleKey="appointments"
            onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
            getRowStyle={(record) => {
                const colorMap = {
                    dangcho: '#aac41a19',       // vàng nhạt
                    dangtrongca: '#188fff2e', // xanh nước biển nhạt
                    daden: '#aac41a19',      // xanh lá nhạt
                    daxong: '#53c41a19',      // xanh lá nhạt
                    dagoi: '#53c41a19',      // xanh lá nhạt
                    dahuy: '#ff7f5023',       // cam nhạt
                    chuaden: '#fff',       // vàng cam nhạt
                };
                return record.status && colorMap[record.status]
                    ? { backgroundColor: colorMap[record.status] }
                    : {};
            }}
            className="no-hover-table"
        />

        return (
            <div>
                <Helmet>
                    <title>{pageTitle}</title>
                </Helmet>
                <PageTitle routes={routes} title="Lịch hẹn" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={checkPermission('appointment', 'remove')}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã, tên, 3 số cuối sđt của khách hàng"
                        filterColSpan={6}
                        activeFilter={
                            query.name ||
                            query.created_at_from ||
                            query.sales_staff ||
                            query.status ||
                            query.branch ||
                            query.service ||
                            query.created_by ||
                            query.examination_doctor_id || query.treatment_doctor_id ||
                            query.implant_doctor_id || query.prosthetic_doctor_id ||
                            query.apprentice_doctor_id || query.assistant_id ||
                            query.customer_source ||
                            query.customer_status ||
                            query.appointment_branch
                        }
                        filters={
                            [
                                <BaseSelect
                                    options={appointmentName || []}
                                    placeholder="Kiểu lịch hẹn"
                                    defaultValue={query.name ? query.name : null}
                                    onChange={(value) => this.onChangeFilter('name', value)}
                                    className="w-100"
                                />,
                                <BaseSelect
                                    options={branchActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn cơ sở"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('branch', value)}
                                    defaultValue={query.branch ? parseInt(query.branch, 10) : null}
                                />,
                                <BaseSelect
                                    options={branchActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn cơ sở thực hiện"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('appointment_branch', value)}
                                    defaultValue={query.appointment_branch ? parseInt(query.appointment_branch, 10) : null}
                                />,
                                <BaseSelect
                                    options={appointmentStatus.concat(appointmentTeleStatus).concat(appointmentNaStatus) || []}
                                    placeholder="Trạng thái lịch hẹn"
                                    className="w-100"
                                    defaultValue={query.status ? query.status : null}
                                    onChange={(value) => this.onChangeFilter('status', value)}
                                />,
                                <BaseSelect
                                    options={customerStatus || []}
                                    placeholder="Trạng thái khách hàng"
                                    className="w-100"
                                    optionLabel="name"
                                    optionValue="id"
                                    defaultValue={query.customer_status ? query.customer_status : null}
                                    onChange={(value) => this.onChangeFilter('customer_status', value)}
                                />,
                                <TreeSelect
                                    showSearch
                                    className="w-100"
                                    dropdownStyle={{ maxHeight: 450, overflow: 'auto' }}
                                    treeData={service}
                                    treeNodeFilterProp='title'
                                    allowClear
                                    placeholder="Dịch vụ"
                                    treeDefaultExpandAll
                                    defaultValue={query.service ? parseInt(query.service, 10) : null}
                                    onChange={(value) => this.onChangeFilter('service', value)}
                                />,
                                <FilterableMultiSelect
                                    options={customerSource || []}
                                    placeholder="Nguồn khách hàng"
                                    parameterName='customer_source'
                                    optionValue="id"
                                    optionLabel="name"
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Nhân viên sales"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('sales_staff', value)}
                                    defaultValue={query.sales_staff ? parseInt(query.sales_staff, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Bác sĩ khám"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('examination_doctor_id', value)}
                                    defaultValue={query.examination_doctor_id ? parseInt(query.examination_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Bác sĩ điều trị" className="w-100"
                                    onChange={(value) => this.onChangeFilter('treatment_doctor_id', value)}
                                    defaultValue={query.treatment_doctor_id ? parseInt(query.treatment_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Bác sĩ cắm trụ" className="w-100"
                                    onChange={(value) => this.onChangeFilter('implant_doctor_id', value)}
                                    defaultValue={query.implant_doctor_id ? parseInt(query.implant_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Bác sĩ phục hình" className="w-100"
                                    onChange={(value) => this.onChangeFilter('prosthetic_doctor_id', value)}
                                    defaultValue={query.prosthetic_doctor_id ? parseInt(query.prosthetic_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Bác sĩ học việc" className="w-100"
                                    onChange={(value) => this.onChangeFilter('apprentice_doctor_id', value)}
                                    defaultValue={query.apprentice_doctor_id ? parseInt(query.apprentice_doctor_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={users || []} optionValue="user_id" optionLabel="display_name" showSearch
                                    placeholder="Phụ tá" className="w-100"
                                    onChange={(value) => this.onChangeFilter('assistant_id', value)}
                                    defaultValue={query.assistant_id ? parseInt(query.assistant_id, 10) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Người tạo"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_by', value)}
                                    defaultValue={query.created_by ? parseInt(query.created_by, 10) : null}
                                />
                            ]
                        }
                    >
                        <RangePicker
                            format="DD/MM/YYYY"
                            placeholder={['Từ ngày', 'Đến ngày']}
                            style={{ width: 250 }}
                            onChange={(value) => this.onChangeFilter('scheduled_at', value)}
                            className='table-button'
                            defaultValue={[
                                query.scheduled_from
                                    ? moment(query.scheduled_from, 'YYYY-MM-DD')
                                    : moment(), // mặc định ngày hiện tại
                                query.scheduled_to
                                    ? moment(query.scheduled_to, 'YYYY-MM-DD')
                                    : moment()  // mặc định ngày hiện tại
                            ]}
                        />
                        <Divider type="vertical" />
                        {
                            checkPermission('telesale_follow_up', 'assign') ? (
                                <Button icon={<UserSwitchOutlined />} className="table-button" type='primary' disabled={!selectedRowKeys.length ? true : false} onClick={() => this.setState({ isTelesaleAssignOpen: true })}>Giao cho telesale</Button>
                            ) : null
                        }
                        {
                            checkPermission('appointment', 'move_appointment') ? (
                                <Button icon={<SwapOutlined />} className="table-button" type='primary' disabled={!selectedRowKeys.length ? true : false} onClick={() => this.setState({ isMoveAppointmentModalOpen: true })}>Chuyển lịch</Button>
                            ) : null
                        }

                        <Button className="table-button" type='primary' icon={<DownloadOutlined />} loading={loadingCapture} onClick={() => this.handleCaptureClick()}>Chụp màn hình</Button>
                        {
                            checkPermission('appointment', 'export') ? (
                                <Button className="table-button" loading={isLoadingExport} type='default' onClick={() => this.startExcelExport()} icon={<ExportOutlined />}>Export</Button>
                            ) : null
                        }
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                    </TableActionBar>
                    {
                        hasSelected ? <Row className="mb-2" align="middle">Đang chọn {selectedRowKeys.length} bản ghi </Row> : ''
                    }
                </div>

                <Row gutter={16} className="mb-2" justify="space-between" style={{ margin: 0 }}>
                    <Card size='small' className="appointment-card w-100">
                        <div className="stats-row">
                            <span className="statistic-label">
                                Tổng số lịch hẹn: <span className="value total">{formatNumber(statistics?.total || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch tư vấn: <span className="value consultant">{formatNumber(statistics?.name?.TUVAN || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch điều trị: <span className="value treatment">{formatNumber(statistics?.name?.LAMDICHVU || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch tái khám: <span className="value recheck">{formatNumber(statistics?.name?.TAIKHAM || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Lịch gọi lại: <span className="value recall">{formatNumber(statistics?.name?.GOILAI || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Hủy lịch: <span className="value danger">{formatNumber(statistics?.status?.dahuy || 0)}</span>
                            </span>
                        </div>

                        <div className="stats-row">
                            <span className="statistic-label">
                                Đã đến: <span className="value arrived">{formatNumber(statistics?.arrived_total || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Chưa đến: <span className="value notarrived">{formatNumber(statistics?.status?.chuaden || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đang chờ: <span className="value waiting">{formatNumber(statistics?.status?.dangcho || statistics?.status?.daden || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đang trong ca: <span className="value inprogress">{formatNumber(statistics?.status?.dangtrongca || 0)}</span>
                            </span>
                            <span className="statistic-label">
                                Đã xong: <span className="value completed">{formatNumber(statistics?.status?.daxong || 0)}</span>
                            </span>
                            <span className="statistic-label">&nbsp;</span>
                        </div>
                        <Divider style={{ margin: '8px 0' }} />
                        <div className="stats-row" style={{ marginBottom: 0 }}>
                            <span className="statistic-label" style={{ display: 'block' }}>
                                Bác sĩ đang trong ca ({statistics?.doctor_in_progress_total || 0}): <span className="doctor_inprogress">{statistics?.doctor_in_progress || ''}</span>
                            </span>
                            <span className="statistic-label" style={{ display: 'block' }}>
                                Bác sĩ ngoài ca ({statistics?.doctor_available_total || 0}): <span className="doctor_available">{statistics?.doctor_available || ''}</span>
                            </span>
                        </div>
                    </Card>
                </Row>

                <Card size='small' className='has-custom-column-table-btn'>
                    <Tabs onChange={(value) => this.onChangeFilter('tab', value)} defaultActiveKey={query.tab} type="card" size="small">
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn hôm nay</span>} key="1">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn ngày mai</span>} key="2">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch hẹn hôm qua</span>} key="4">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch chưa xác định</span>} key="5">
                            <div ref={this.tableRef}>
                                <Alert
                                    style={{ border: 'none' }}
                                    message="Danh sách các khách hàng chưa hẹn được cụ thể lịch hẹn tiếp theo, cần chú ý liên hệ chăm sóc lại thường xuyên."
                                    type="warning"
                                />
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Lịch chưa đến, chưa gọi</span>} key="6">
                            <div ref={this.tableRef}>
                                <Alert
                                    style={{ border: 'none' }}
                                    message="Danh sách khách hàng đã có lịch hẹn nhưng chưa đến (hoặc chưa gọi lại cho khách), cần gọi lại để hẹn lịch mới hàng ngày."
                                    type="warning"
                                />
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Tất cả lịch hẹn</span>} key="3">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                    </Tabs>
                </Card>


                <AppointmentDetail
                    visible={isOpenDetail}
                    currentItem={currentData}
                    onCancel={() => this.toggleOpenDetail(false)}
                />

                <TelesaleFollowUpAssignForm
                    visible={isTelesaleAssignOpen}
                    customerIds={customerIds}
                    onCancel={() => this.onCancel()}
                />
                <AppointmentForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => this.loadData(query)}
                    onCancel={() => this.toggleOpenForm(false)}
                />

                <AppointmentUpdateStatus
                    visible={isOpenStatusForm}
                    currentItem={currentItem}
                    reloadData={() => this.loadData(query)}
                    onCancel={() => this.setState({ isOpenStatusForm: false })}
                />

                <Modal
                    title="Chuyển lịch hẹn"
                    visible={isMoveAppointmentModalOpen}
                    header={false}
                    onOk={(e) => this.handleMoveAppointment(e)}
                    width={isMobile ? '100%' : '40%'}
                    onCancel={() => this.onCancel()}
                    maskClosable={false}
                    footer={[
                        <Button key="back" onClick={() => this.onCancel()}>
                            Cancel
                        </Button>,
                        <Button
                            loading={loadingMoveAppointment}
                            key="submit"
                            type="primary"
                            onClick={(e) => this.handleMoveAppointment(e)}
                        >
                            OK
                        </Button>,
                    ]}
                >
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Alert
                                    message="Lưu ý"
                                    type="info"
                                    showIcon
                                    className='mb-5 fix-alert-element'
                                    description={<>
                                        Chỉ chuyển lịch <strong>Điều trị</strong> và lịch <strong>
                                            Tái khám</strong>
                                    </>}
                                />
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label='Lịch hẹn'>
                                    {getFieldDecorator("name", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: null
                                    })(
                                        <BaseSelect
                                            options={appointmentName}
                                            showSearch
                                            placeholder="Chọn một bản ghi"
                                            style={{ width: '100%' }}
                                            onChange={(value) => this.changeName(value)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            {
                                requireTime ? (
                                    <Col xs={24} md={24}>
                                        <Form.Item label="Thời gian">
                                            {getFieldDecorator('scheduled_at', {
                                                rules: [
                                                    {
                                                        required: requireTime,
                                                        message: 'Vui lòng điền!',
                                                    },
                                                ],
                                                initialValue: null
                                            })(
                                                <DatePicker
                                                    style={{ width: '100%' }}
                                                    showTime={{ format: 'HH:mm', defaultValue: moment('00:00', 'HH:mm') }} // Giới hạn giờ và phút là 00:00
                                                    format="DD/MM/YYYY HH:mm"
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                ) : null
                            }
                        </Row>
                    </Form>
                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        appointments: state.appointmentReducer.list.data,
        pagination: state.appointmentReducer.list.pagination,
        statistics: state.appointmentReducer.statistics,
        users: state.config.users,
        auth: state.auth.authUser,
        doctors: state.config.doctors,
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListAppointments: (filter) => dispatch(getListAppointments(filter)),
        getSpecificAppointment: (id) => dispatch(getSpecificAppointment(id)),
        removeAppointment: (ids) => dispatch(removeAppointment(ids)),
        transferAppointmentToStaff: (data) => dispatch(transferAppointmentToStaff(data)),
        moveAppointment: (data) => dispatch(moveAppointment(data)),
        exportAppointmentsExcel: (filter) => dispatch(exportAppointmentsExcel(filter)),
        getAppointmentsStatistics: (filter) => dispatch(getAppointmentsStatistics(filter)),
        fetchFilters: () => dispatch(fetchFilters()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'AppointmentList' })(AppointmentList));

